import { CenterItem } from '@components/LinearLayout';
import { EVENT_HOME_WIDTH } from '@utils/constants';
import styled from 'styled-components';

export const AgendaItemsRoot = styled.div`
  width: min(${EVENT_HOME_WIDTH}, 100%);
  margin: auto;
  gap: 5rem;
  margin-bottom: 5rem;
`;

export const NoSessionWrapper = styled(CenterItem)`
  height: 20rem;
`;

export const BannerSection = styled.div`
  display: flex;
  width: 100%;
  height: 17.5rem;

  margin-top: 4rem;
  margin-bottom: 4rem;

  border-radius: ${({ theme }) => theme.borderRadius.radius10};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    height: auto;

    margin-top: 3rem;
    margin-bottom: 3rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export const LeftColumn = styled.div<{ bgImage: string }>`
  flex: 0 0 60%;
  background-image: url(${({ bgImage }) => bgImage});
  background-size: cover;
  background-position: center;

  border-top-left-radius: ${({ theme }) => theme.borderRadius.radius10};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.radius10};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    display: none;
  }
`;

export const RightColumn = styled.div`
  flex: 0 0 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2rem;

  padding: 2rem 8rem;

  background-color: ${({ theme }) => theme.color.mobilityGrey};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.radius10};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.radius10};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    position: relative;
    flex: 1;
    align-items: flex-start;
    width: 100%;

    padding: 4rem 2rem 2rem 2rem;

    border-radius: ${({ theme }) => theme.borderRadius.radius10};
    text-align: left;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const CloseIconWrapper = styled.span`
  position: absolute;
  right: 1rem;
  top: 1rem;
`;
